import { EmitEventNodeDataSchema } from '@cotera/api';
import type { WorkflowNodeData } from '../types';
import type {
  WorkflowNodeHydration,
  WorkflowNodeUpstreamRef,
} from '../workflow-node-base';
import type { WorkflowNodeOutputShapeContext } from '../workflow-node-output-shape';
import { TypedWorkflowNode } from './typed-workflow-node';

/**
 * Emits a named org-scoped event with a payload built from upstream field
 * bindings. Passes its input through unchanged so the same-workflow branch
 * continues after the emit.
 */
export class EmitEventWorkflowNode extends TypedWorkflowNode<
  typeof EmitEventNodeDataSchema
> {
  protected readonly schema = EmitEventNodeDataSchema;

  static override create(
    data: WorkflowNodeData,
    hydration: WorkflowNodeHydration
  ): EmitEventWorkflowNode {
    return new EmitEventWorkflowNode(data, hydration);
  }
  override deriveTypedOutputShape(
    context: WorkflowNodeOutputShapeContext
  ): string | null {
    return context.resolvePredecessorOutputShape?.(this.id) ?? null;
  }

  override upstreamRefs(): readonly WorkflowNodeUpstreamRef[] {
    return this.bindingMapRefs(this.config?.payloadBindings);
  }
}
